import {expireDefault} from "./Config";
//工具类
export const setLocalStorage =(key, data)  => {
  window.localStorage.setItem(key, data);
};
export const getLocalStorage =(key)  => {
  let data = window.localStorage.getItem(key);
  return data;
};
export const setLocalStorageExpire =(key, data, expire)  => {
  if (null  === expire || undefined === expire){
    expire = expireDefault;
  }
  let value =  getLocalStorageExpire(key);
  if (value !== null && value !== ''){
    return value;
  }
  let seconds = Date.now();
  window.localStorage.setItem(key, data);
  window.localStorage.setItem('expire'+key, seconds + expire);
  debugger;
};
export const getLocalStorageExpire =(key)  => {
  let seconds = Date.now();
  let data = getLocalStorage(key);
  let expire = getLocalStorage('expire'+key);
  if (null === expire){
    expire = 0;
  }
  if(seconds - expire > 0){
    deleteLocalStorage(key);
    deleteLocalStorage('expire'+key);
    return '';
  }
  return data;
};
//
export const setLocalStorageToJsonString =(key, data)  => {
  window.localStorage.setItem(key, JSON.stringify(data));
};
export const deleteLocalStorage =(key)  => {
  let data = window.localStorage.removeItem(key);
  console.log(data, key, "removeItem");
  return data;
};
export const clearToken =(loginUserKey)  => {
  let user1 = getLocalStorage(loginUserKey);
  let json = JSON.parse(user1);
  console.log(user1, "clearToken-user");
  deleteLocalStorage(json.username + "-token");
  deleteLocalStorage(loginUserKey);
};



// WEBPACK FOOTER //
// ./src/utils/CommonUtil.js